---@meta

---@class Json
---@field encode fun(self: Json, value: any): string, string
---@field decode fun(self: Json, value: string): any, string

json = {} ---@type Json
